import { FaGlobe, FaBolt, FaStar, FaShieldAlt } from "react-icons/fa";

const features = [
  { icon: <FaGlobe />, label: "Stunning Website Design" },
  { icon: <FaBolt />, label: "Fast & Reliable Delivery" },
  { icon: <FaStar />, label: "Modern UI/UX Experience" },
  { icon: <FaShieldAlt />, label: "Built for Your Business" },
];

export const ChallengeFeatures = () => (
  <div className="challenge-features">
    {features.map((f) => (
      <div className="challenge-feature" key={f.label}>
        <span className="challenge-feature-icon">{f.icon}</span>
        <span className="challenge-feature-label">{f.label}</span>
      </div>
    ))}
  </div>
);

export const ChallengeTagline = () => (
  <div className="challenge-tagline">Give TTH the Challenge!</div>
);

export const ChallengeQrCard = () => (
  <div className="challenge-qr-card">
    <div className="challenge-qr-top">Your Website Design</div>
    <div className="challenge-qr-highlight">In Just 24 Hours.</div>
    <div className="challenge-qr-box">
      <img
        src="/assets/home banner/Qr_code.png"
        alt="Scan to challenge TTH"
        loading="lazy"
      />
    </div>
    <div className="challenge-qr-scan">Scan. Share.</div>
    <div className="challenge-qr-cta">Challenge TTH.</div>
  </div>
);
